import React from "react"
import ExperienceTextInput from "./experience-text-input"
import { FormattedMessage, useIntl } from "react-intl"

const ExperienceInputCoursework = ({ type }) => {
  const { formatMessage } = useIntl()

  return (
    <>
      <ExperienceTextInput
        placeholder={formatMessage({ id: 'resume-experience-coursework-form-title-placeholder', defaultMessage: "Ex. Advanced Shielded Metal Arc Welding" })}
        label={<FormattedMessage
          id="resume-experience-form-course-title"
          defaultMessage="Course Title"
        />}
        dataKey="title"
        required={true}
      />
      <ExperienceTextInput
        placeholder={formatMessage({ id: 'resume-experience-coursework-form-school-placeholder', defaultMessage: "Ex. New England Institute of Technology" })}
        label={<FormattedMessage
          id="resume-experience-form-associated-organization"
          defaultMessage="Associated Organization"
        />}
        dataKey="school"
      />
      <ExperienceTextInput
        placeholder={formatMessage({ id: 'resume-experience-coursework-form-description-placeholder', defaultMessage: "Ex. Performed advanced study of SMAW, focusing on code compliant weldments and 7018 fill and cover passes for 100 percent weld in positions 1G, 2G, 3G and 4G." })}
        label={<FormattedMessage
          id="resume-experience-form-description"
          defaultMessage="Description"
        />}
        dataKey="description"
        inputType="textarea"
      />
    </>
  )
}

export default ExperienceInputCoursework
